import { Store, PlayCircle, Loader2 } from 'lucide-react';
import StoreCard from '../StoreCard';

export default function StoreGrid({
    filteredStores,
    stores,
    query,
    filterStatus,
    queueStatus,
    handleCheckAllPages,
    handleValidationComplete,
    currentlyValidatingStore,
    validationProgressByStore
}) {
    return (
        <>
            {/* Results Info with Check All Button */}
            <div className="mb-6">
                <div className="flex items-center justify-between">
                    <p className="font-medium" style={{ color: 'var(--color-text-secondary)' }}>
                        Showing <span style={{ color: 'var(--color-primary)' }}>{filteredStores.length}</span> of{' '}
                        <span style={{ color: 'var(--color-primary)' }}>{stores.length}</span> stores
                        {query && (
                            <span>
                                {' '}for "<span style={{ color: 'var(--color-primary)' }}>{query}</span>"
                            </span>
                        )}
                    </p>

                    {/* Check All Button - Only show when filtering by error or pending */}
                    {(filterStatus === 'error' || filterStatus === 'pending') && filteredStores.length > 0 && (
                        <button
                            onClick={handleCheckAllPages}
                            disabled={queueStatus.isProcessing && queueStatus.queueLength > 0}
                            className={`
                                flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold
                                transition-all duration-200 border-2 shadow-md
                                ${queueStatus.isProcessing && queueStatus.queueLength > 0
                                    ? 'bg-gray-100 text-gray-400 border-gray-300 cursor-not-allowed opacity-60'
                                    : 'bg-gradient-to-r from-orange-500 to-orange-600 text-white border-orange-600 hover:from-orange-600 hover:to-orange-700 hover:shadow-lg hover:scale-105 active:scale-100'
                                }
                            `}
                            title={`Validate all ${filteredStores.filter(s => s.pages.length > 0).length} ${filterStatus === 'error' ? 'stores with errors' : 'pending stores'}`}
                        >
                            {queueStatus.isProcessing && queueStatus.queueLength > 0 ? (
                                <>
                                    <Loader2 size={18} className="animate-spin" />
                                    <span>Processing Queue ({queueStatus.queueLength} remaining)</span>
                                </>
                            ) : (
                                <>
                                    <PlayCircle size={18} />
                                    <span>Check All Pages ({filteredStores.filter(s => s.pages.length > 0).length})</span>
                                </>
                            )}
                        </button>
                    )}
                </div>
            </div>

            {/* Store Grid */}
            {filteredStores.length === 0 ? (
                <div className="text-center py-16">
                    <div className="p-6 rounded-2xl max-w-md mx-auto" style={{ backgroundColor: 'var(--color-surface-secondary)' }}>
                        <Store size={48} style={{ color: 'var(--color-text-tertiary)' }} className="mx-auto mb-4" />
                        <p className="text-lg font-medium mb-2" style={{ color: 'var(--color-text-primary)' }}>
                            {query ? 'No stores match your search' : 'No stores found'}
                        </p>
                        <p style={{ color: 'var(--color-text-secondary)' }}>
                            {query ? 'Try adjusting your search terms' : 'Add your first store to get started'}
                        </p>
                    </div>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {filteredStores.map((store, index) => (
                        <div key={store._id} className="animate-fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
                            <StoreCard
                                store={store}
                                onValidationComplete={handleValidationComplete}
                                isExternallyValidating={currentlyValidatingStore === store.name}
                                externalValidationProgress={validationProgressByStore[store.name]}
                            />
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}
